import { render } from "./GlobalProp.vue?vue&type=template&id=2c6517fc"
import script from "./GlobalProp.vue?vue&type=script&lang=js"
export * from "./GlobalProp.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__